import Quill from 'quill/core';
import 'quill/dist/quill.snow.css';
import Bold from 'quill/formats/bold';
import Italic from 'quill/formats/italic';
import Strike from 'quill/formats/strike';
import Underline from 'quill/formats/underline';
import Toolbar from 'quill/modules/toolbar';
import Snow from 'quill/themes/snow';

Quill.register({
  'modules/toolbar': Toolbar,
  'themes/snow': Snow,
  'formats/bold': Bold,
  'formats/italic': Italic,
  'formats/underline': Underline,
  'formats/strike': Strike,
});

export default Quill;
